import { Trans } from 'react-i18next';
import { SvgIcon } from '@progress/kendo-react-common';
import { saveIcon } from '@progress/kendo-svg-icons';

interface SaveBarProps {
    onClick: () => void;
    disabled?: boolean;
}

export function SaveBar({ onClick, disabled }: SaveBarProps) {
    return (
        <div className="save-bar">
            <button type="button" className="lm-btn-primary" onClick={onClick} disabled={disabled}>
                <SvgIcon icon={saveIcon} /> <Trans>general.save</Trans>
            </button>
        </div>
    );
}
